<template>
  <footer class="footer">
    <div class="footer-container">
      <div class="footer-menu">
        <div class="footer-column">
          <h3>Navigation</h3>
          <ul class="map">
            <li><router-link :to="{ name: 'home' }">Accueil</router-link></li>
            <li><router-link :to="{ name: 'help' }">Aide</router-link></li>
            <li><router-link :to="{ name: 'about' }">À propos</router-link></li>
            <li><router-link :to="{ name: 'about', hash: '#contact' }">Contact</router-link></li>
            <li v-if="!userStore.user">
              <router-link :to="{ name: 'login' }">Se connecter</router-link>
            </li>
            <li v-if="!userStore.user">
              <router-link :to="{ name: 'register' }">S'inscrire</router-link>
            </li>
            <li v-if="!userStore.user">
              <router-link :to="{ name: 'validate' }">Valider votre inscription</router-link>
            </li>
            <li v-if="!userStore.user">
              <router-link :to="{ name: 'forgot' }">Récupérer votre mot de passe</router-link>
            </li>
          </ul>
        </div>
        <div class="footer-column">
          <h3>Nous suivre</h3>
          <ul class="social">
            <li>
              <a href="#" target="_blank" rel="noopener" class="disabled-link">
                <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32
                32">
                  <path
                    d="M16,2c-7.732,0-14,6.268-14,14,0,6.566,4.52,12.075,10.618,13.588v-9.31h-2.887v-4.278h2.887v-1.843c0-4.765,2.156-6.974,6.835-6.974,.887,0,2.417,.174,3.043,.348v3.878c-.33-.035-.904-.052-1.617-.052-2.296,0-3.183,.87-3.183,3.13v1.513h4.573l-.786,4.278h-3.787v9.619c6.932-.837,12.304-6.74,12.304-13.897,0-7.732-6.268-14-14-14Z">
                  </path>
                </svg> Facebook</a>
            </li>
            <li>
              <a href="#" target="_blank" rel="noopener" class="disabled-link">
                <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32">
                  <path
                    d="M18.42,14.009L27.891,3h-2.244l-8.224,9.559L10.855,3H3.28l9.932,14.455L3.28,29h2.244l8.684-10.095,6.936,10.095h7.576l-10.301-14.991h0Zm-3.074,3.573l-1.006-1.439L6.333,4.69h3.447l6.462,9.243,1.006,1.439,8.4,12.015h-3.447l-6.854-9.804h0Z">
                  </path>
                </svg> Twitter</a>
            </li>
            <li>
              <a href="#" target="_blank" rel="noopener" class="disabled-link">
                <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32
                32">
                  <path
                    d="M10.202,2.098c-1.49,.07-2.507,.308-3.396,.657-.92,.359-1.7,.84-2.477,1.619-.776,.779-1.254,1.56-1.61,2.481-.345,.891-.578,1.909-.644,3.4-.066,1.49-.08,1.97-.073,5.771s.024,4.278,.096,5.772c.071,1.489,.308,2.506,.657,3.396,.359,.92,.84,1.7,1.619,2.477,.779,.776,1.559,1.253,2.483,1.61,.89,.344,1.909,.579,3.399,.644,1.49,.065,1.97,.08,5.771,.073,3.801-.007,4.279-.024,5.773-.095s2.505-.309,3.395-.657c.92-.36,1.701-.84,2.477-1.62s1.254-1.561,1.609-2.483c.345-.89,.579-1.909,.644-3.398,.065-1.494,.081-1.971,.073-5.773s-.024-4.278-.095-5.771-.308-2.507-.657-3.397c-.36-.92-.84-1.7-1.619-2.477s-1.561-1.254-2.483-1.609c-.891-.345-1.909-.58-3.399-.644s-1.97-.081-5.772-.074-4.278,.024-5.771,.096m.164,25.309c-1.365-.059-2.106-.286-2.6-.476-.654-.252-1.12-.557-1.612-1.044s-.795-.955-1.05-1.608c-.192-.494-.423-1.234-.487-2.599-.069-1.475-.084-1.918-.092-5.656s.006-4.18,.071-5.656c.058-1.364,.286-2.106,.476-2.6,.252-.655,.556-1.12,1.044-1.612s.955-.795,1.608-1.05c.493-.193,1.234-.422,2.598-.487,1.476-.07,1.919-.084,5.656-.092,3.737-.008,4.181,.006,5.658,.071,1.364,.059,2.106,.285,2.599,.476,.654,.252,1.12,.555,1.612,1.044s.795,.954,1.051,1.609c.193,.492,.422,1.232,.486,2.597,.07,1.476,.086,1.919,.093,5.656,.007,3.737-.006,4.181-.071,5.656-.06,1.365-.286,2.106-.476,2.601-.252,.654-.556,1.12-1.045,1.612s-.955,.795-1.608,1.05c-.493,.192-1.234,.422-2.597,.487-1.476,.069-1.919,.084-5.657,.092s-4.18-.007-5.656-.071M21.779,8.517c.002,.928,.755,1.679,1.683,1.677s1.679-.755,1.677-1.683c-.002-.928-.755-1.679-1.683-1.677,0,0,0,0,0,0-.928,.002-1.678,.755-1.677,1.683m-12.967,7.496c.008,3.97,3.232,7.182,7.202,7.174s7.183-3.232,7.176-7.202c-.008-3.97-3.233-7.183-7.203-7.175s-7.182,3.233-7.174,7.203m2.522-.005c-.005-2.577,2.08-4.671,4.658-4.676,2.577-.005,4.671,2.08,4.676,4.658,.005,2.577-2.08,4.671-4.658,4.676-2.577,.005-4.671-2.079-4.676-4.656h0">
                  </path>
                </svg> Instagram</a>
            </li>
            <li>
              <a href="#" target="_blank" rel="noopener" class="disabled-link">
                <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32">
                  <path
                    d="M26.111,3H5.889c-1.595,0-2.889,1.293-2.889,2.889V26.111c0,1.595,1.293,2.889,2.889,2.889H26.111c1.595,0,2.889-1.293,2.889-2.889V5.889c0-1.595-1.293-2.889-2.889-2.889ZM10.861,25.389h-3.877V12.87h3.877v12.519Zm-1.957-14.158c-1.267,0-2.293-1.034-2.293-2.31s1.026-2.31,2.293-2.31,2.292,1.034,2.292,2.31-1.026,2.31-2.292,2.31Zm16.485,14.158h-3.858v-6.571c0-1.802-.685-2.809-2.111-2.809-1.551,0-2.362,1.048-2.362,2.809v6.571h-3.718V12.87h3.718v1.686s1.118-2.069,3.775-2.069,4.556,1.621,4.556,4.975v7.926Z"
                    fill-rule="evenodd"></path>
                </svg> LinkedIn</a>
            </li>
            <li>
              <a href="#" target="_blank" rel="noopener" class="disabled-link">
                <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32
                  32">
                  <path
                    d="M25.873,6.069c-2.619-2.623-6.103-4.067-9.814-4.069C8.411,2,2.186,8.224,2.184,15.874c-.001,2.446,.638,4.833,1.852,6.936l-1.969,7.19,7.355-1.929c2.026,1.106,4.308,1.688,6.63,1.689h.006c7.647,0,13.872-6.224,13.874-13.874,.001-3.708-1.44-7.193-4.06-9.815h0Zm-9.814,21.347h-.005c-2.069,0-4.099-.557-5.87-1.607l-.421-.25-4.365,1.145,1.165-4.256-.274-.436c-1.154-1.836-1.764-3.958-1.763-6.137,.003-6.358,5.176-11.531,11.537-11.531,3.08,.001,5.975,1.202,8.153,3.382,2.177,2.179,3.376,5.077,3.374,8.158-.003,6.359-5.176,11.532-11.532,11.532h0Zm6.325-8.636c-.347-.174-2.051-1.012-2.369-1.128-.318-.116-.549-.174-.78,.174-.231,.347-.895,1.128-1.098,1.359-.202,.232-.405,.26-.751,.086-.347-.174-1.464-.54-2.788-1.72-1.03-.919-1.726-2.054-1.929-2.402-.202-.347-.021-.535,.152-.707,.156-.156,.347-.405,.52-.607,.174-.202,.231-.347,.347-.578,.116-.232,.058-.434-.029-.607-.087-.174-.78-1.88-1.069-2.574-.281-.676-.567-.584-.78-.595-.202-.01-.433-.012-.665-.012s-.607,.086-.925,.434c-.318,.347-1.213,1.186-1.213,2.892s1.242,3.355,1.416,3.587c.174,.232,2.445,3.733,5.922,5.235,.827,.357,1.473,.571,1.977,.73,.83,.264,1.586,.227,2.183,.138,.666-.1,2.051-.839,2.34-1.649,.289-.81,.289-1.504,.202-1.649s-.318-.232-.665-.405h0Z"
                    fill-rule="evenodd"></path>
                </svg> +33673142635</a>
            </li>
          </ul>
        </div>
        <div class="footer-column">
          <h3>Villes de départ</h3>
          <ul class="city-start">
            <li v-for="city in citiesStore.cities" :key="city.id">
              <router-link :to="`/search/start/${city.slug}`">{{ city.name }}</router-link>
            </li>
          </ul>
        </div>
        <div class="footer-column">
          <h3>Villes d'arrivée</h3>
          <ul class="city-end">
            <li v-for="city in citiesStore.cities" :key="city.id">
              <router-link :to="`/search/arrived/${city.slug}`">{{ city.name }}</router-link>
            </li>
          </ul>
        </div>
        <div class="footer-column">
          <h3>Télécharger l'application</h3>
          <ul class="download-app">
            <li class="btn-footer disabled"><img src="../assets/images/download-appstore.png"></li>
            <li>
              <a href="#" class="btn-footer"><img src="../assets/images/download-googleplay.png"></a>
            </li>
          </ul>
          <ul class="theme-toggle-container">
            <li>
              <button type="button" class="theme-toggle" @click="themeStore.toggleTheme" aria-label="Changer le thème">
                <span class="toggle-track" :class="{ dark: themeStore.isDark }">
                  <span class="toggle-thumb" :class="{ dark: themeStore.isDark }"></span>
                </span>
                <span class="theme-icon" :class="{ dark: themeStore.isDark }">
                  <!-- LUNE -->
                  <svg v-if="themeStore.isDark" xmlns="http://www.w3.org/2000/svg" width="18" height="18"
                    viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                    stroke-linejoin="round">
                    <path d="M21 12.79A9 9 0 1 1 11.21 3 7 7 0 0 0 21 12.79z"></path>
                  </svg>
                  <!-- SOLEIL -->
                  <svg v-else xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none"
                    stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                    <circle cx="12" cy="12" r="5"></circle>
                    <line x1="12" y1="1" x2="12" y2="3"></line>
                    <line x1="12" y1="21" x2="12" y2="23"></line>
                    <line x1="4.22" y1="4.22" x2="5.64" y2="5.64"></line>
                    <line x1="18.36" y1="18.36" x2="19.78" y2="19.78"></line>
                    <line x1="1" y1="12" x2="3" y2="12"></line>
                    <line x1="21" y1="12" x2="23" y2="12"></line>
                    <line x1="4.22" y1="19.78" x2="5.64" y2="18.36"></line>
                    <line x1="18.36" y1="5.64" x2="19.78" y2="4.22"></line>
                  </svg>
                </span>
              </button>
            </li>

          </ul>
        </div>
      </div>
      <div class="footer-divider"></div>
      <p class="footer-text">
        {{ settingsStore.footerText }}
      </p>
    </div>
  </footer>
</template>

<script setup>
import { onMounted } from 'vue'
import { useCitiesStore } from '@/stores/citiesStore'
import { useSettingsStore } from '@/stores/settingsStore'
import { useUserStore } from '../stores/userStore'
import { useThemeStore } from '../stores/themeStore'

const userStore = useUserStore()
const settingsStore = useSettingsStore()
const citiesStore = useCitiesStore()
const themeStore = useThemeStore()

onMounted(() => {
  citiesStore.fetchCities()
})
</script>

<style scoped>
.footer {
  font-family: var(--font-family-text);
  background-color: var(--color-jungle);
  backdrop-filter: blur(8px);
  -webkit-backdrop-filter: blur(8px);
  padding: 4rem 1rem;
  color: var(--color-eclat);
  width: 100%;
  /* margin-top: 4rem; */
}

.footer-container {
  max-width: 1200px;
  margin: 0 auto;
  display: grid;
  grid-template-columns: 1fr;
  gap: 2rem;
}

.footer-menu {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 2rem;
  width: 100%;
}

.footer-column {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

.footer-column h3 {
  font-size: 1rem;
  font-weight: 600;
  margin: 0;
  color: var(--color-eclat);
}

.footer-column ul {
  display: flex;
  flex-direction: column;
  gap: 0.8rem;
  list-style: none;
  padding: 0;
  margin: 0;
}

.footer-menu a {
  color: var(--color-eclat);
  text-decoration: none;
  font-weight: 500;
  transition: all 0.3s;
}

.footer-menu a:hover,
.footer-menu a.router-link-active {
  color: var(--color-eclat);
  text-decoration: none;
  font-weight: 500;
}

.footer-divider {
  width: 100%;
  height: 1px;
  background: linear-gradient(to right,
      transparent,
      var(--color-eclat),
      transparent);
  opacity: 0.3;
}

.footer-text {
  font-size: 0.9rem;
  margin: 0;
  text-align: center;
  width: 100%;
  grid-column: 1 / -1;
}

.social li {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  color: var(--color-eclat);
}

.social svg {
  fill: var(--color-eclat);
  font-size: 0.5rem;
  vertical-align: middle;
}

.disabled-link {
  pointer-events: none;
  opacity: 0.3;
}

.footer-menu .footer-column:last-of-type ul {
  align-items: flex-start;
  width: 100%;
}

.footer-menu .footer-column:last-of-type ul:last-of-type {
  flex: 2;
  justify-content: flex-start;
}

.footer-column ul.download-app {
  flex-direction: row;
  flex-wrap: wrap;
}

.toggle-track.dark {
  background-color: var(--color-eclat);
}

.theme-icon.dark {
  color: var(--color-eclat);
}

.toggle-thumb.dark {
  color: var(--color-jungle);
  background-color: var(--color-jungle);
}

/* Responsive */
@media (max-width: 768px) {
  .footer {
    padding: 2rem 1rem;
  }

  .footer-menu {
    grid-template-columns: 1fr 1fr;
  }

  .subscribe {
    grid-column: 1 / -1;
  }

  .footer-column ul.download-app {
    justify-content: center;
  }

}

.download-app:deep() {
  gap: 0.5rem !important;
  align-items: flex-start;
}

.btn-footer img {
  width: 150px;
}

@media (max-width: 480px) {
  .footer-menu {
    grid-template-columns: 1fr;
  }
}
</style>
